import { useFeature } from "flagged";

import { AUTH_AI_ASSISTANT } from "domain/authority";
import { FLAG_AI_HOME } from "services/feature/FeatureFlagService";
import { hasAiAssistantLicenseBundle } from "services/tenants/tenantCookieService";
import { userSessionService } from "services/user/UserSessionService";

export function useIsAiHomeEnabled(): boolean {
    const isFlagEnabled = useFeature(FLAG_AI_HOME);
    return (
        isFlagEnabled && hasAiAssistantLicenseBundle() && userSessionService.userHasAnyAuthority([AUTH_AI_ASSISTANT])
    );
}
